<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="大屏" />
  </div>
</template>


<script>
// 列表默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { getbuylist } from "@/api/report";
import { itemClassGetList, getshoplist } from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
export default {
  name: "ws",
  data() {
    return {
      comp_id: 0,
      total: 0,
      searchParameters: Object.assign({}, defaultParameters),
      apiBase: process.env.VUE_APP_BASE_API || 'https://erp.zuizhenshi.cn',
    };
  },
  created() {
    // this.getData();
    this.comp_id = JSON.parse(getRoles()).comp_id;
    if (this.comp_id > 0) {
      window.location.href =
        this.apiBase + "/index.html#/bigDataScreen?comp_id=" +
        this.comp_id;
    } else {
      this.$router.push("/login");
    }
  },
  methods: {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/ws/index.vue